import colors from '@rategravity/frontend/theme/colors';
import React from 'react';
import BooleanRadioButtons from '../components/BooleanRadioButtons';
import Card from '../components/card';
import { CurrencyTextField, DollarTextField } from '../components/MaskedTextField';
import { equalsOrContains } from '../modules/employment-helper';
import style from '../styles/form';
import { BorrowerCard, CoborrowerCard } from './card-lenses';

const validateIncome = (num) => (num > 0 ? '' : 'Please enter a dollar amount');

const incomeField = (FieldType, onChange, prop, model, hintText, label) => (
  <div>
    <FieldType
      key={prop}
      value={model.get(prop)}
      style={style.threeQuarters}
      hintText={hintText}
      floatingLabelFixed
      floatingLabelText={label}
      floatingLabelStyle={{ color: colors.primary, fontSize: 21.33, top: 28 }}
      onChange={onChange.bind(null, prop)}
      validate={validateIncome}
    />
  </div>
);

const getPossessivePronoun = (id) => (id === 'borrower' ? 'your' : 'their');
const getPersonalPronoun = (id) => (id === 'borrower' ? 'you' : 'they');

const salaryField = (onChange, model, id) =>
  incomeField(
    DollarTextField,
    onChange,
    'salary',
    model,
    '$/year',
    `What is ${getPossessivePronoun(id)} annual base salary?`
  );

const wageField = (onChange, model, id) =>
  incomeField(
    CurrencyTextField,
    onChange,
    'hourly',
    model,
    '$/hour',
    `What is ${getPossessivePronoun(id)} hourly wage?`
  );

const incomeDeclinedField = (id, onChange, model) => {
  const employment = model.get('employment');
  return (
    <div>
      <br />
      <p>
        {equalsOrContains('Salaried', employment)
          ? `Is ${getPossessivePronoun(
              id
            )} current annualized salary less than the income ${getPersonalPronoun(
              id
            )} earned last year?`
          : `Is ${getPossessivePronoun(
              id
            )} current hourly wage lower than at any point during the previous calendar year?`}
      </p>
      <BooleanRadioButtons
        name="incomeDeclined"
        value={model.get('incomeDeclined')}
        onChange={onChange.bind(null, 'incomeDeclined')}
      />
    </div>
  );
};

const EmploymentInfo = ({ model, onChange, id, ...cardProps }) => {
  const onEmploymentLengthChanged = (newValue) => {
    onChange('employmentLength', newValue);
    if (newValue === false) {
      // If you're at your job for less than a month we can safely say
      //   you haven't been there for two years. I'm like 99% certain
      //   that's how time works.
      onChange('twoYearsAtCurrentJob', false);
    }
  };

  const employment = model.get('employment');

  return (
    <Card {...cardProps}>
      <br />
      <p>
        Have {getPersonalPronoun(id)} been at {getPossessivePronoun(id)} current job for at least a
        month?
      </p>
      <BooleanRadioButtons
        name="employmentLength"
        value={model.get('employmentLength')}
        onChange={onEmploymentLengthChanged}
      />
      {incomeDeclinedField(id, onChange, model)}
      <br />
      <p>Are {getPersonalPronoun(id)} paid a bonus?</p>
      <BooleanRadioButtons
        name="bonus"
        value={model.get('bonus')}
        onChange={onChange.bind(null, 'bonus')}
      />
      <br />
      <p>Are {getPersonalPronoun(id)} paid a commission?</p>
      <BooleanRadioButtons
        name="commission"
        value={model.get('commission')}
        onChange={onChange.bind(null, 'commission')}
      />
      <br />
      {equalsOrContains('Salaried', employment)
        ? salaryField(onChange, model, id)
        : wageField(onChange, model, id)}
    </Card>
  );
};

EmploymentInfo.completed = ({ model }) => {
  const employment = model.get('employment');
  return (
    model.get('incomeDeclined') != null &&
    model.get('bonus') != null &&
    model.get('commission') != null &&
    model.get('employmentLength') != null &&
    (equalsOrContains('Salaried', employment)
      ? !DollarTextField.validate(model.get('salary'), validateIncome)
      : !CurrencyTextField.validate(model.get('hourly'), validateIncome))
  );
};

export const PrimaryEmploymentInfo = BorrowerCard(EmploymentInfo, 'PrimaryEmploymentInfo', {
  title: 'Tell us about your job...',
  id: 'borrower'
});

export const CoborrowerEmploymentInfo = CoborrowerCard(EmploymentInfo, 'CoborrowerEmploymentInfo', {
  title: 'Tell us about their job...',
  id: 'coborrower'
});



// WEBPACK FOOTER //
// ./src/cards/employment-info.js